import { WContainer, WImage } from '@components/atoms'
import { CollezioneItemType } from '@utils/types'
import styles from './Opus.module.sass'
import { OpusNode } from '@gql/graphql'
import useTrans from '@hooks/useTrans'

interface Props {
  opus: OpusNode
  className?: string
}

const Opus = (props: Props) => {
  const { opus = undefined, className = '' } = props

  const t = useTrans()

  return opus ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer className={styles.container}>
        {!!opus.nome && <h2 className={styles.title}>{opus.nome}</h2>}
        <div className={styles.innerContainer}>
          {!!opus.imageUrl && (
            <div className={styles.imageBox}>
              <WImage
                className={styles.image}
                src={opus.imageUrl}
                alt={opus.imageAlt}
                maxWidth={295}
                maxHeight={281}
              />
            </div>
          )}
          <div className={styles.opusInfoContainer}>
            {!!opus.opusCodesPerFormati?.length && (
              <div className={styles.upperContainer}>
                {opus.opusCodesPerFormati.map((opusCode) => (
                  <div className={styles.opusCodesContainer}>
                    <p className={styles.opusCodeKey}>{opusCode.numPezzi} {t('pz./pcs')}</p>
                
                    <p className={styles.opusCodeValue}>
                      {opusCode.formato.lato1Cm} x {opusCode.formato.lato2Cm}  {t('cm')} -{' '}
                      {opusCode.formato.lato1Intero}{' '}
                      <sup>
                        {opusCode.formato.lato1Numeratore} / {opusCode.formato.lato1Denominatore}
                        &quot;
                      </sup>{' '}
                      x {opusCode.formato.lato2Intero}{' '}
                      <sup>
                        {opusCode.formato.lato2Numeratore} / {opusCode.formato.lato2Denominatore}
                        &quot;
                      </sup>
                    </p>
                  </div>
                ))}
              </div>
            )}
            {!!opus.opusCodesPerArticoli?.length && (
              <div className={styles.lowerContainer}>
                {!!opus.descrizione && <p className={styles.description}>{opus.descrizione}</p>}
                {opus.opusCodesPerArticoli.map((opusCode) => (
                  <div className={styles.opusCodesContainer}>
                    <p className={styles.opusCodeKey}>{opusCode.codiceCatalogo}</p>
                    <p className={styles.opusCodeValue}>
                      
                      {opusCode?.articolo?.tonalita?.nome} {opusCode?.articolo?.superficie?.nome}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default Opus
